
import * as moment from "moment";

import { findIndex } from "../../shared/common/linq";
import { SESSION_REFRESH, SESSION_INIT } from "../../shared/timeclock/actions";
import { RefreshSessionResponse } from "../../shared/timeclock/services/api";
import { Signature } from "../../shared/timeclock/models";

export interface SignatureRegistry {
    items: Signature[];
    lastUpdate: moment.Moment;
}

interface SignatureAction {
    type: string;
    refreshResponse: RefreshSessionResponse;
}

function equalSignatureMeta(left: Signature, right: Signature) {
    return  left.device === right.device &&
            left.meta === right.meta &&
            left.personRef === right.personRef;
}

function updateSignatures(existing: Signature[], incoming: Signature[]) {
    const items = [...existing];

    incoming.forEach((incSign) => {
        const index = findIndex(items, (s) => equalSignatureMeta(s, incSign));
        if (index >= 0) {
            items[index].data = incSign.data;
        } else {
            items.push(incSign);
        }
    });

    return items;
}

export function signatures(state: SignatureRegistry, action: SignatureAction): SignatureRegistry {

    if (state === undefined) {
        return { items: [], lastUpdate: moment() };
    }

    switch (action.type) {
        case SESSION_INIT:
            return { items: action.refreshResponse.signatures, lastUpdate: moment() };
        case SESSION_REFRESH:
            return {
                items: updateSignatures(state.items, action.refreshResponse.signatures),
                lastUpdate: moment()
            };
        default:
            return state;
    }
}
